import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationStateService {
  private notificationReadSubject = new Subject<{
    notificationId: number;
    isRead: boolean;
  }>();

  public notificationRead$ = this.notificationReadSubject.asObservable();

  notifyRead(notificationId: number, isRead: boolean): void {
    this.notificationReadSubject.next({ notificationId, isRead });
  }
}
